// extracted by mini-css-extract-plugin
module.exports = {"textContent":"_404-module--textContent--SIb7m","anchor":"_404-module--anchor--1eUfW"};